import { render } from "./Leave_Ammendments.vue?vue&type=template&id=7ebd06c2"
import script from "./Leave_Ammendments.vue?vue&type=script&lang=js"
export * from "./Leave_Ammendments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__